import React, { Component } from 'react'
import { Icon } from 'antd'
import './search-filter.css'
import Fuse from 'fuse.js'

class searchFilter extends Component {

    constructor(props) {
        super(props);
        this.keyHandler = this.keyHandler.bind(this)
    }

    keyHandler(event, dataSource, searchInput) {
        if (event.key === 'Enter') {
            this.fuseFilter(dataSource, searchInput)
        }
    }

    fuseFilter(list = [], input) {
        if (input === '') return
        let keys = []
        for (let key in list[0]) keys.push(key)
        var options = {
            threshold: 0.2,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys: keys,
            shouldSort: true
        };
        var fuse = new Fuse(list, options);
        let result = fuse.search(input);
        this.props.updateData(result)
    }

    render() {
        const { dataSource = [], searchInput = '', className = '', title = 'Search', iconName = 'search', onChange, placeholder = 'Pesquisar' } = this.props
        return (
            <section className={`search ${className}`}>
                <button title={title} className='search-btn' onClick={() => this.fuseFilter(dataSource, searchInput)}>
                    <Icon type={iconName} />
                </button>
                <input onChange={onChange}
                    onKeyUp={(event) => this.keyHandler(event, dataSource, searchInput)}
                    value={searchInput}
                    type='text'
                    placeholder={placeholder}
                    className='search-input'
                    id='search-table' />
            </section >
        );
    }
}

export default searchFilter



// WEBPACK FOOTER //
// ./src/App/components/search-filter/search-filter.js